"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePersonalAction = exports.updatePasswordAction = exports.updateEmailAction = exports.sendWithdraw2faKeyAction = exports.resetGetWalletAddressAction = exports.resetGetTotpKeyAction = exports.resetEnableTotpAction = exports.resetDisableTotpAction = exports.getWalletAddressAction = exports.getTotpKeyAction = exports.fetchUserRequirementsAction = exports.fetchUserAction = exports.enableWithdraw2faAction = exports.enableTotpAction = exports.enableEmail2faAction = exports.disableWithdraw2faAction = exports.disableTotpAction = exports.disableEmail2faAction = exports.createWalletAddressAction = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../../api");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var fetchUserAction = (0, _toolkit.createAsyncThunk)('user/get', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var response;
  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _api.UserApi.get();
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
exports.fetchUserAction = fetchUserAction;
var getWalletAddressAction = (0, _toolkit.createAsyncThunk)('user/getWalletAddress', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var response,
    _args2 = arguments;
  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _api.UserApi.getWalletAddress.apply(_api.UserApi, _args2);
        case 2:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));
exports.getWalletAddressAction = getWalletAddressAction;
var resetGetWalletAddressAction = (0, _toolkit.createAction)('user/getWalletAddress/reset');
exports.resetGetWalletAddressAction = resetGetWalletAddressAction;
var createWalletAddressAction = (0, _toolkit.createAsyncThunk)('user/createWalletAddress', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var response,
    _args3 = arguments;
  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return _api.UserApi.createWalletAddress.apply(_api.UserApi, _args3);
        case 2:
          response = _context3.sent;
          return _context3.abrupt("return", response);
        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
})));
exports.createWalletAddressAction = createWalletAddressAction;
var updatePersonalAction = (0, _toolkit.createAsyncThunk)('user/updatePersonal', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    var response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _api.UserApi.updatePersonal(params);
          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function (_x) {
    return _ref4.apply(this, arguments);
  };
}());
exports.updatePersonalAction = updatePersonalAction;
var updatePasswordAction = (0, _toolkit.createAsyncThunk)('user/updatePassword', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    var response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api.UserApi.updatePassword(params);
          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response);
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function (_x2) {
    return _ref5.apply(this, arguments);
  };
}());
exports.updatePasswordAction = updatePasswordAction;
var updateEmailAction = (0, _toolkit.createAsyncThunk)('user/updateEmail', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(email) {
    var response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _api.UserApi.updateEmail(email);
          case 2:
            response = _context6.sent;
            return _context6.abrupt("return", response);
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function (_x3) {
    return _ref6.apply(this, arguments);
  };
}());
exports.updateEmailAction = updateEmailAction;
var enableEmail2faAction = (0, _toolkit.createAsyncThunk)('user/enableEmail2fa', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var response;
  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return _api.UserApi.enableEmail2fa();
        case 2:
          response = _context7.sent;
          return _context7.abrupt("return", response);
        case 4:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7);
})));
exports.enableEmail2faAction = enableEmail2faAction;
var disableEmail2faAction = (0, _toolkit.createAsyncThunk)('user/disableEmail2fa', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var response;
  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return _api.UserApi.disableEmail2fa();
        case 2:
          response = _context8.sent;
          return _context8.abrupt("return", response);
        case 4:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8);
})));
exports.disableEmail2faAction = disableEmail2faAction;
var enableWithdraw2faAction = (0, _toolkit.createAsyncThunk)('user/enableWithdraw2fa', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var response;
  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return _api.UserApi.enableWithdraw2fa();
        case 2:
          response = _context9.sent;
          return _context9.abrupt("return", response);
        case 4:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9);
})));
exports.enableWithdraw2faAction = enableWithdraw2faAction;
var disableWithdraw2faAction = (0, _toolkit.createAsyncThunk)('user/disableWithdraw2fa', /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
    var response;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _api.UserApi.disableWithdraw2fa(params);
          case 2:
            response = _context10.sent;
            return _context10.abrupt("return", response);
          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return function (_x4) {
    return _ref10.apply(this, arguments);
  };
}());
exports.disableWithdraw2faAction = disableWithdraw2faAction;
var sendWithdraw2faKeyAction = (0, _toolkit.createAsyncThunk)('user/sendWithdraw2faKeyAction', /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_, _ref11) {
    var rejectWithValue, response;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            rejectWithValue = _ref11.rejectWithValue;
            _context11.prev = 1;
            _context11.next = 4;
            return _api.UserApi.sendWithdraw2faKey();
          case 4:
            response = _context11.sent;
            return _context11.abrupt("return", response);
          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](1);
            if (!(_context11.t0 instanceof _api.ResendCodeLimitError)) {
              _context11.next = 12;
              break;
            }
            return _context11.abrupt("return", rejectWithValue(_context11.t0));
          case 12:
            throw _context11.t0;
          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 8]]);
  }));
  return function (_x5, _x6) {
    return _ref12.apply(this, arguments);
  };
}());
exports.sendWithdraw2faKeyAction = sendWithdraw2faKeyAction;
var enableTotpAction = (0, _toolkit.createAsyncThunk)('user/enableTotp', /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    var response;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _api.UserApi.enableTotp(params);
          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response);
          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return function (_x7) {
    return _ref13.apply(this, arguments);
  };
}());
exports.enableTotpAction = enableTotpAction;
var disableTotpAction = (0, _toolkit.createAsyncThunk)('user/disableTotp', /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    var response;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _api.UserApi.disableTotp(params);
          case 2:
            response = _context13.sent;
            return _context13.abrupt("return", response);
          case 4:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return function (_x8) {
    return _ref14.apply(this, arguments);
  };
}());
exports.disableTotpAction = disableTotpAction;
var getTotpKeyAction = (0, _toolkit.createAsyncThunk)('user/getTotpKey', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var response;
  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return _api.UserApi.getTotpKey();
        case 2:
          response = _context14.sent;
          return _context14.abrupt("return", response);
        case 4:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14);
})));
exports.getTotpKeyAction = getTotpKeyAction;
var resetEnableTotpAction = (0, _toolkit.createAction)('user/enableTotp/reset');
exports.resetEnableTotpAction = resetEnableTotpAction;
var resetDisableTotpAction = (0, _toolkit.createAction)('user/disableTotp/reset');
exports.resetDisableTotpAction = resetDisableTotpAction;
var resetGetTotpKeyAction = (0, _toolkit.createAction)('user/getTotpKey/reset');
exports.resetGetTotpKeyAction = resetGetTotpKeyAction;
var fetchUserRequirementsAction = (0, _toolkit.createAsyncThunk)('user/requirements/get', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var response;
  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return _api.UserApi.getRequirements();
        case 2:
          response = _context15.sent;
          return _context15.abrupt("return", response);
        case 4:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15);
})));
exports.fetchUserRequirementsAction = fetchUserRequirementsAction;